import {Component, input, InputSignal} from '@angular/core';
import {AdvancedSearchTab} from './advanced-search-tab';
import {DsMessageModule, DsProgressCircleModule} from '@bmw-ds/components';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-advanced-search-tab',
  templateUrl: './advanced-search-tab.component.html',
  styleUrls: ['./advanced-search-tab.component.scss'],
  imports: [DsProgressCircleModule, DsMessageModule, TranslateModule]
})
export class AdvancedSearchTabComponent {

  readonly selectedTab: InputSignal<AdvancedSearchTab> = input<AdvancedSearchTab>();
}
